import { render, staticRenderFns } from "./DesignLTDetail.vue?vue&type=template&id=9981c110&scoped=true&"
import script from "./DesignLTDetail.vue?vue&type=script&lang=js&"
export * from "./DesignLTDetail.vue?vue&type=script&lang=js&"
import style0 from "./DesignLTDetail.vue?vue&type=style&index=0&id=9981c110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9981c110",
  null
  
)

export default component.exports